var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgOpenBook = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 23,
    height: 15,
    viewBox: "0 0 23 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.085 12.6688V1.98643C8.31772 -0.414563 4.70945 -0.0652662 3.25122 0.409506V11.1936C6.30333 10.0135 9.74543 11.6854 11.085 12.6688ZM2.82234 12.2268C6.61691 10.7179 10.0435 12.6891 11.2824 13.8634C7.48786 11.5112 2.72987 13.512 0.825195 14.8065V2.43529H2.82234V12.2268ZM11.8152 12.6688V1.98643C14.5824 -0.414563 18.1907 -0.0652662 19.6489 0.409506V11.1936C16.5968 10.0135 13.1547 11.6854 11.8152 12.6688ZM20.0778 12.2268C16.2832 10.7179 12.8567 12.6891 11.6177 13.8634C15.4123 11.5112 20.1703 13.512 22.0749 14.8065V2.43529H20.0778V12.2268Z"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgOpenBook);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/OpenBook.2d97137e62308964f5a7c57318f58a9a.svg";